import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useLensBundle } from '../../../../LensBundles/context.js';
import MonthlyPrice from './MonthlyPrice.js';

const MonthlyPriceContainer = ()=>{
    const { currency , getLabel  } = useIntl();
    const { pricePerMonth  } = useLensBundle();
    const labels = React.useMemo(()=>({
            perMonth: getLabel('common.frequency.perMonth')
        })
    , [
        getLabel
    ]);
    if (!pricePerMonth) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(MonthlyPrice, {
        currency: currency,
        labels: labels,
        price: pricePerMonth
    });
};

export { MonthlyPriceContainer as default };
//# sourceMappingURL=MonthlyPriceContainer.js.map
